(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('FaqDetailController', FaqDetailController);

    FaqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Faq'];

    function FaqDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Faq) {
        var vm = this;

        vm.faq = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:faqUpdate', function(event, result) {
            vm.faq = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
